/*
*   !!! 该目录已废弃，日期工具函数已迁移至  tools > toolDate
* */

class Calendar {

  constructor() {

  }

  /* 获取当年 */
  getCurrentYear() {
    const date = new Date();
    return date.getFullYear();
  }

  /* 补0 */
  fillZero(val) {
    return val < 10 ? ('0' + val) : val;
  }

  /* 获取年月日周 */
  getDate(dateStr) {
    // const date = dateStr == undefined ? new Date() : new Date(dateStr);
    let date;
    if (!dateStr){
      date = new Date();
    }else {
      let dateArray = dateStr.split("-");
      date = new Date(dateArray[0], parseInt(dateArray[1] - 1));
    }

    const year = date.getFullYear(); //获取完整的年份(4位,1970-????)
    const month = date.getMonth() + 1; //获取当前月份(0-11,0代表1月)
    const day = date.getDate(); //获取当前日(1-31)
    const hours = date.getHours(); //获取当前日(1-31)
    const week = date.getDay(); //获取当前星期X(0-6,0代表星期天)
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    return {
      year,
      month,
      day,
      week,
      hours,
      minutes,
      seconds,
      date: year + '-' + month + '-' + day
    }
  }

  //判断某年某月的1号是星期几
  getFirstDay(_year, _month) {
    var allDay = 0, y = _year - 1, i = 1;
    allDay = y + Math.floor(y / 4) - Math.floor(y / 100) + Math.floor(y / 400) + 1;
    for (; i < _month; i++) {
      switch (i) {
        case 1:
          allDay += 31;
          break;
        case 2:
          if (this.isLeapYear(_year)) {
            allDay += 29;
          } else {
            allDay += 28;
          }
          break;
        case 3:
          allDay += 31;
          break;
        case 4:
          allDay += 30;
          break;
        case 5:
          allDay += 31;
          break;
        case 6:
          allDay += 30;
          break;
        case 7:
          allDay += 31;
          break;
        case 8:
          allDay += 31;
          break;
        case 9:
          allDay += 30;
          break;
        case 10:
          allDay += 31;
          break;
        case 11:
          allDay += 30;
          break;
        case 12:
          allDay += 31;
          break;
      }
    }
    return allDay % 7;
  }

  /* 闰年 */
  isLeapYear(_year) {
    if (_year % 400 === 0 || (_year % 4 === 0 && _year % 100 !== 0)) {
      return true;
    }
    return false;
  }

  /* 获取月天数 */
  getMonthDays(_year, _month) {
    let monthDay = 0;
    //月份的天数
    switch (_month) {
      case 1:
        monthDay = 31;
        break;
      case 2:
        if (this.isLeapYear(_year)) {
          monthDay = 29;
        } else {
          monthDay = 28;
        }
        break;
      case 3:
        monthDay = 31;
        break;
      case 4:
        monthDay = 30;
        break;
      case 5:
        monthDay = 31;
        break;
      case 6:
        monthDay = 30;
        break;
      case 7:
        monthDay = 31;
        break;
      case 8:
        monthDay = 31;
        break;
      case 9:
        monthDay = 30;
        break;
      case 10:
        monthDay = 31;
        break;
      case 11:
        monthDay = 30;
        break;
      case 12:
        monthDay = 31;
        break;
    }

    return monthDay;
  }

  getWeek(dateString){
    var date;
    if (!dateString) {
      date = new Date();
    } else {
      var dateArray = dateString.split("-");
      date = new Date(dateArray[0], parseInt(dateArray[1] - 1), dateArray[2]);
    }
    // return "星期" + "日一二三四五六".charAt(date.getDay());
    return date.getDay()
  }


  getCalenderData(_year, _month) {
    const preDay = this.getFirstDay(_year, _month)
    const monthDay = this.getMonthDays(_year, _month);

    // 自定义数据格式
    let dateData = [];
    _month = this.fillZero(_month)
    if (_month.length == 1){
      _month = this.fillZero(_month)
    }
    for (let i = 1; i <= monthDay; i++) {

      let obj = {
        day: i,
        month: _month,
        date: `${_year}-${_month}-`+this.fillZero(i),
        fillZeroDate: _month + '-' + this.fillZero(i),
        lunar: this.toLunar(_year, _month-1, i).lunarDayCn,
        solarTerm: this.toLunar(_year, _month-1, i).solarTerm,
        actData:[]
        // holidaysCN: this.HolidaysCN(`${_year}-${_month}-${i}`)
      }
      dateData.push(obj);
    }
    let text =  this.getWeek(`${_year}-${_month}-${monthDay}`)
    return {
      dateData,
      preDays: preDay,
      nextDays: 7 - parseInt(text)-1
    };
  }

  //显示日历
  showCalendar(_year, _month, _day, firstDay) {
    var i = 0,
      monthDay = 0,
      showStr = "",
      _classname = "",
      today = new Date();
    //月份的天数
    switch (_month) {
      case 1:
        monthDay = 31;
        break;
      case 2:
        if (this.isLeapYear(_year)) {
          monthDay = 29;
        } else {
          monthDay = 28;
        }
        break;
      case 3:
        monthDay = 31;
        break;
      case 4:
        monthDay = 30;
        break;
      case 5:
        monthDay = 31;
        break;
      case 6:
        monthDay = 30;
        break;
      case 7:
        monthDay = 31;
        break;
      case 8:
        monthDay = 31;
        break;
      case 9:
        monthDay = 30;
        break;
      case 10:
        monthDay = 31;
        break;
      case 11:
        monthDay = 30;
        break;
      case 12:
        monthDay = 31;
        break;
    }

    //输出日历表格，这部分因结构而异
    showStr = "<table class='cld-w'><thead>";
    //日历头部
    showStr += "<tr><th colspan='7'><div class='cld-hd'><span class='cld-pre'><</span><em id='showDate' value='" + _year + "-" + _month + "-" + _day + "'>" + _year + "年" + _month + "月" + _day + "日" + "</em><span class='cld-next'>></span></div></th></tr>";
    //日历星期
    showStr += "<tr>" +
      "<th>日</th>" +
      "<th>一</th>" +
      "<th>二</th>" +
      "<th>三</th>" +
      "<th>四</th>" +
      "<th>五</th>" +
      "<th>六</th></tr>";
    showStr += "</thead><tbody><tr>";
    //当月第一天前的空格
    for (i = 1; i <= firstDay; i++) {
      showStr += "<td></td>";
    }
    //显示当前月的天数
    for (i = 1; i <= monthDay; i++) {
      //当日的日期
      if (_year === today.getFullYear() && _month === today.getMonth() + 1 && i === today.getDate()) {
        _classname = "cld-cur";
      }
      //当日之前的日期（这个判断是因为我有工作需求，就是要求之前的日期不能点击）
      else if (_year < today.getFullYear() || (_year === today.getFullYear() && _month <= today.getMonth()) || (_year === today.getFullYear() && _month === today.getMonth() + 1 && i < today.getDate())) {
        _classname = "cld-old";
      }
      //其他普通的日期
      else {
        _classname = "cld-day";
      }
      //其他大于当月的月份的相同日期（为了让点击下一月的时候，相同的日期增加cld-cur类）
      if (_day === i && (_year > today.getFullYear() || _month > today.getMonth() + 1)) {
        _classname = "cld-cur";
      }
      //把日期存在对应的value
      showStr += "<td class=" + _classname + " value='" + _year + "-" + _month + "-" + i + "'>" + i + "</td>";

      firstDay = (firstDay + 1) % 7;
      if (firstDay === 0 && i !== monthDay) {
        showStr += "</tr><tr>";
      }
    }
    //剩余的空格
    if (firstDay !== 0) {
      for (i = firstDay; i < 7; i++) {
        showStr += "<td></td>";
      }
    }

    showStr += "</tr></tbody></table>";
    //插入calendar的页面结构里
    // calendar.innerHTML = showStr;
    return showStr
  }

  /* 转农历 */
  toLunar(solarYear, solarMonth, solarDay) {

    let lunarInfo = [
      0x04bd8, 0x04ae0, 0x0a570, 0x054d5, 0x0d260, 0x0d950, 0x16554, 0x056a0, 0x09ad0, 0x055d2,
      0x04ae0, 0x0a5b6, 0x0a4d0, 0x0d250, 0x1d255, 0x0b540, 0x0d6a0, 0x0ada2, 0x095b0, 0x14977,
      0x04970, 0x0a4b0, 0x0b4b5, 0x06a50, 0x06d40, 0x1ab54, 0x02b60, 0x09570, 0x052f2, 0x04970,
      0x06566, 0x0d4a0, 0x0ea50, 0x06e95, 0x05ad0, 0x02b60, 0x186e3, 0x092e0, 0x1c8d7, 0x0c950,
      0x0d4a0, 0x1d8a6, 0x0b550, 0x056a0, 0x1a5b4, 0x025d0, 0x092d0, 0x0d2b2, 0x0a950, 0x0b557,
      0x06ca0, 0x0b550, 0x15355, 0x04da0, 0x0a5d0, 0x14573, 0x052d0, 0x0a9a8, 0x0e950, 0x06aa0,
      0x0aea6, 0x0ab50, 0x04b60, 0x0aae4, 0x0a570, 0x05260, 0x0f263, 0x0d950, 0x05b57, 0x056a0,
      0x096d0, 0x04dd5, 0x04ad0, 0x0a4d0, 0x0d4d4, 0x0d250, 0x0d558, 0x0b540, 0x0b5a0, 0x195a6,
      0x095b0, 0x049b0, 0x0a974, 0x0a4b0, 0x0b27a, 0x06a50, 0x06d40, 0x0af46, 0x0ab60, 0x09570,
      0x04af5, 0x04970, 0x064b0, 0x074a3, 0x0ea50, 0x06b58, 0x055c0, 0x0ab60, 0x096d5, 0x092e0,
      0x0c960, 0x0d954, 0x0d4a0, 0x0da50, 0x07552, 0x056a0, 0x0abb7, 0x025d0, 0x092d0, 0x0cab5,
      0x0a950, 0x0b4a0, 0x0baa4, 0x0ad50, 0x055d9, 0x04ba0, 0x0a5b0, 0x15176, 0x052b0, 0x0a930,
      0x07954, 0x06aa0, 0x0ad50, 0x05b52, 0x04b60, 0x0a6e6, 0x0a4e0, 0x0d260, 0x0ea65, 0x0d530,
      0x05aa0, 0x076a3, 0x096d0, 0x04bd7, 0x04ad0, 0x0a4d0, 0x1d0b6, 0x0d250, 0x0d520, 0x0dd45,
      0x0b5a0, 0x056d0, 0x055b2, 0x049b0, 0x0a577, 0x0a4b0, 0x0aa50, 0x1b255, 0x06d20, 0x0ada0]

    let zodiacs = ['鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊', '猴', '鸡', '狗', '猪']
    let Gan = ['甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸']
    let Zhi = ['子', '丑', '寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌', '亥']
    let weekday = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日']


    //==== 传入 offset 传回干支, 0=甲子
    function cyclical(num) {
      return(Gan[num % 10] + Zhi[num % 12])
    }

    //==== 传回农历 year年的总天数
    function lYearDays(year) {
      let i, sum = 348
      for(i = 0x8000; i > 0x8; i >>= 1) {
        sum += (lunarInfo[year - 1900] & i) ? 1: 0
      }
      return(sum + leapDays(year))
    }

    //==== 传回农历 year年闰月的天数
    function leapDays(year) {
      if(leapMonth(year)) {
        return((lunarInfo[year-1900] & 0x10000)? 30: 29)
      }
      else {
        return 0
      }
    }

    //==== 传回农历 year年闰哪个月 1-12 , 没闰传回 0
    function leapMonth(year) {
      return(lunarInfo[year - 1900] & 0xf)
    }

    //==== 传回农历 year年month月的总天数
    function monthDays(year, month) {
      return( (lunarInfo[year - 1900] & (0x10000 >> month))? 30: 29 )
    }

    //==== 算出农历, 传入日期对象, 传回农历日期对象
    //     该对象属性有 农历年year 农历月month 农历日day 是否闰年isLeap yearCyl dayCyl monCyl
    function Lunar(objDate) {
      let i, temp = 0
      let baseDate = new Date(1900,0,31)
      let offset   = Math.floor((objDate - baseDate)/86400000)

      let dayCyl = offset + 40
      let monCyl = 14

      for(i = 1900; i < 2050 && offset > 0; i++) {
        temp = lYearDays(i)
        offset -= temp
        monCyl += 12
      }
      if(offset < 0) {
        offset += temp;
        i--;
        monCyl -= 12
      }
      //农历年
      let year = i
      let yearCyl = i-1864

      let leap = leapMonth(i) //闰哪个月
      let isLeap = false  //是否闰年

      for(i=1; i<13 && offset>0; i++) {
        //闰月
        if(leap>0 && i === (leap+1) && isLeap === false) {
          --i; isLeap = true; temp = leapDays(year);
        }
        else {
          temp = monthDays(year, i);
        }

        //解除闰月
        if(isLeap === true && i === (leap + 1)) {
          isLeap = false
        }

        offset -= temp
        if(isLeap === false) {
          monCyl ++
        }
      }

      if(offset === 0 && leap>0 && i===leap+1)
        if(isLeap) {
          isLeap = false
        }
        else {
          isLeap = true
          --i
          --monCyl
        }

      if(offset<0){
        offset += temp
        --i
        --monCyl
      }
      //农历月
      let month = i
      //农历日
      let day = offset + 1

      return {
        year: year,
        month: month,
        day: day,
        isLeap: isLeap,
        leap: leap,
        yearCyl: yearCyl,
        dayCyl: dayCyl,
        monCyl: monCyl
      }
    }

    //==== 中文日期 m为传入月份，d为传入日期
    function cDay(m, d){
      let nStr1 = ['日', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十']
      let nStr2 = ['初', '十', '廿', '卅', '']
      //农历中文月
      let lunarMonthCn
      //农历中文日
      let lunarDayCn
      if (m > 10){
        lunarMonthCn = '十' + nStr1[m - 10]
      } else {
        lunarMonthCn = nStr1[m]
      }
      lunarMonthCn += '月'

      switch (d) {
        case 10: lunarDayCn = '初十'; break;
        case 20: lunarDayCn = '二十'; break;
        case 30: lunarDayCn = '三十'; break;
        default: lunarDayCn = nStr2[Math.floor(d/10)] + nStr1[d % 10]
      }
      return {
        lunarMonthCn: lunarMonthCn,
        lunarDayCn: lunarDayCn
      }
    }

    //节气
    function getSolarTerm(GY,GM,GD) {
      let sTermInfo = [
        0, 21208, 42467, 63836, 85337, 107014,
        128867, 150921, 173149, 195551, 218072, 240693,
        263343, 285989, 308563, 331033, 353350, 375494,
        397447, 419210, 440795, 462224, 483532, 504758
      ]
      let solarTerm = [
        '小寒', '大寒', '立春', '雨水', '惊蛰', '春分',
        '清明', '谷雨', '立夏', '小满', '芒种', '夏至',
        '小暑', '大暑', '立秋', '处暑', '白露', '秋分',
        '寒露', '霜降', '立冬', '小雪', '大雪', '冬至'
      ]

      let solarTerms = ''
      let tmp1 = new Date(
        (31556925974.7 * (GY - 1900) + sTermInfo[GM * 2 + 1] * 60000) + Date.UTC(1900,0,6,2,5)
      )
      let tmp2 = tmp1.getUTCDate()
      if (tmp2 === GD) solarTerms = solarTerm[GM * 2 + 1]
      tmp1 = new Date(
        (31556925974.7 * (GY - 1900) + sTermInfo[GM * 2] * 60000) + Date.UTC(1900,0,6,2,5)
      )
      tmp2= tmp1.getUTCDate()
      if (tmp2 === GD) solarTerms = solarTerm[GM * 2]

      return solarTerms
    }

    let sDObj = new Date(solarYear, solarMonth, solarDay);
    let lDObj = new Lunar(sDObj);
    let lunarDayCn = cDay(lDObj.month,lDObj.day).lunarDayCn
    let solarTerm = getSolarTerm(solarYear,solarMonth,solarDay)
    return {
      lunarDayCn,
      solarTerm
    };
  }


  /* 获取几天后的时间 */
  getNextDate(date,day,isShowRangArr = true) {
    var dd = new Date(date);
    dd.setDate(dd.getDate() + day-1);
    var y = dd.getFullYear();
    var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
    var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
    let endTime = y + "-" + m + "-" + d;

    if (isShowRangArr){
      return this.getAllDateCN(date,endTime)
    }

    return endTime;
  }

  /* 获取指定日期上一天、下一天 */
  getTomorrowInfo(date, day) {
    var dd = new Date(date);
    dd.setDate(dd.getDate() + day);
    var y = dd.getFullYear();
    var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
    var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
    return y + "-" + m + "-" + d;
  }

  getAllDateCN(starDay, endDay) {
    var arr = [];

    var dates = [];
    // 设置两个日期UTC时间
    var db = new Date(starDay);
    var de = new Date(endDay);

    // 获取两个日期GTM时间
    var s = db.getTime() - 24 * 60 * 60 * 1000;
    var d = de.getTime() - 24 * 60 * 60 * 1000;
    // 获取到两个日期之间的每一天的毫秒数
    for (var i = s; i <= d;) {
      i = i + 24 * 60 * 60 * 1000;
      arr.push(parseInt(i))
    }
    // 获取每一天的时间  YY-MM-DD
    for( var j in arr ){
      var time = new Date(arr[j]);
      var year = time.getFullYear(time);
      // var mouth = (time.getMonth() + 1)>=10?(time.getMonth() + 1):('0'+(time.getMonth() + 1));
      var mouth = (time.getMonth() + 1);
      // var day = time.getDate()>=10?time.getDate():('0'+time.getDate());
      var day = time.getDate();
      var YYMMDD = year + '-' + mouth + '-' + day;
      dates.push(YYMMDD)
    }



    return dates
  }


  /* 中国节假日 */
  HolidaysCN(monthDayStr){
    const data = [
      {
        date: '2022-3-1',
        val:'元旦节',
        days: 3
      },
     {
        date: '2022-1-31',
        val:'春节',
        days: 7
      },
       {
        date: '2022-4-3',
        val:'清明节',
        days: 3
      },
      {
        date: '2022-4-30',
        val:'劳动节',
        days: 5
      },
      {
        date: '2022-6-3',
        val:'端午节',
        days: 3
      },
      {
        date: '2022-9-10',
        val:'中秋节',
        days: 3
      },
      {
        date: '2022-10-1',
        val:'国庆节',
        days: 3
      },
    ]
    let temp = {}
    let holidays = []
    data.forEach(item =>{
      /* 获取所有的休息时间 */
      let monthDayStrArr = this.getNextDate(item.date,item.days)
      holidays = holidays.concat(monthDayStrArr)
      if (item.date === monthDayStr){
        temp.name = item.val;
      }
    })

    temp.isRest = holidays.indexOf(monthDayStr) > -1;

    return temp
  }


  prepend(arr, item) {
    return [item].concat(arr);
  }
}

export default new Calendar();
